import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const defaultOptions = {
  autoClose: 1500
};

const groupMessages = {
  NEW_CHAT: [],
  NEW_MESSAGE: [],
  TRANSFER_CHAT: [],
  CHAT_CLOSED: [],
  ERROR: []
};

let intervalId;

class ToastFlex {
  static init() {
    if (intervalId) return;
    intervalId = setInterval(() => {
      if (groupMessages.TRANSFER_CHAT.length > 0) {
        if (groupMessages.TRANSFER_CHAT.length === 1) {
          toast.info(`Conversa transferida`, defaultOptions);
          groupMessages.TRANSFER_CHAT = [];
          return;
        }

        toast.info(
          `${groupMessages.TRANSFER_CHAT.length} conversas foram transferidas`,
          defaultOptions
        );
        groupMessages.TRANSFER_CHAT = [];
      }

      if (groupMessages.NEW_MESSAGE.length > 0) {
        if (groupMessages.NEW_MESSAGE.length === 1) {
          toast.info(`Você tem uma nova mensagem`, defaultOptions);
          groupMessages.NEW_MESSAGE = [];
          return;
        }

        toast.info(
          `Existem ${groupMessages.NEW_MESSAGE.length} novas mensagens`,
          defaultOptions
        );

        groupMessages.NEW_MESSAGE = [];
      }

      if (groupMessages.NEW_CHAT.length > 0) {
        if (groupMessages.NEW_CHAT.length === 1) {
          toast.info(`Você recebeu uma nova conversa`, defaultOptions);
          groupMessages.NEW_CHAT = [];
          return;
        }

        toast.info(
          `Você recebeu ${groupMessages.NEW_CHAT.length} novas conversas`,
          defaultOptions
        );

        groupMessages.NEW_CHAT = [];
      }

      if (groupMessages.CHAT_CLOSED.length > 0) {
        if (groupMessages.CHAT_CLOSED.length === 1) {
          toast.info(`Conversa encerrada`, defaultOptions);
          groupMessages.CHAT_CLOSED = [];
          return;
        }

        toast.info(
          `${groupMessages.CHAT_CLOSED.length} conversas foram encerradas`,
          defaultOptions
        );
        groupMessages.CHAT_CLOSED = [];
      }
    }, 3000);
  }
  static success(message, options = defaultOptions) {
    toast.success(message, options);
  }

  static error(message, options = defaultOptions) {
    toast.error(message, options);
  }

  static info(message, permission, groupType, options = defaultOptions) {
    if (!permission) return;
    this.init();
    if (groupType === 'NEW_MESSAGE') {
      groupMessages[groupType].push(message);
      return;
    }
    toast.info(message, options);
  }

  static warning(message, options = defaultOptions) {
    toast.warning(message, options);
  }

  static default(message, options = defaultOptions) {
    toast(message, options);
  }

  static configure(options = defaultOptions) {
    toast.configure(options);
  }
}

export default ToastFlex;
